export default (key) => {
  return String(key)
    .replaceAll('.', '_')
    .replaceAll('[', '_')
    .replaceAll(']', '_');
};
